import { lineLogin, getLineToken } from '@/services/lineApi.service'

export default {
    namespaced: true,
    state: {
        lineLoginData: {}
    },
    getters: {
        accessToken: (state) => {
            return state.lineLoginData?.access_token ?? ''
        },
        idToken: (state) => {
            return state.lineLoginData?.id_token ?? ''
        },
    },
    mutations: {
        setLineLoginData(state, lineLoginData) {
            state.lineLoginData = lineLoginData;
        }
    },
    actions: {
        login(_, data) {
            return lineLogin(data)
        },
        async getToken({commit}, {code, state}) {
            commit('setLineLoginData', await getLineToken(code, state))
        }
    }
}